import BaseMedia from "@PegasusCore/pegasus-one-media/src/script";

class Media extends BaseMedia {
    lightbox = null;
    init() {
        super.init();

        this.$nextTick(async () => {
            if (!this.lightbox) {
                const { default: GLightbox } = await import("glightbox");
                this.lightbox = GLightbox({
                    selector: ".trigger-video-modal",
                    videosWidth: "1280px", 
                    closeOnOutsideClick: true,
                    keyboardNavigation: false,
                    touchNavigation: true,
                    loop: false,
                    plyr: {
                        config: {
                            ratio: '16:9', 
                            youtube: {
                                noCookie: true,
                                rel: 0,
                                showinfo: 0,
                                iv_load_policy: 3,
                                modestbranding: 1,
                                vq: 'hd1080'
                            }
                        }
                    }
                });
            }
        });
    }
}

document.addEventListener("alpine:init", () => {
    Alpine.data(
        "mediaBlock",
        () =>
            new Media()
    );
});

export default Media;